var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parking-pan-zoom" },
    [
      _c(
        "SvgPanZoom",
        {
          class: ["plan-wrapper"],
          staticStyle: { width: "100%", height: "100%" },
          attrs: {
            zoomEnabled: false,
            mouseWheelZoomEnabled: false,
            dblClickZoomEnabled: false,
            fit: false,
            center: false,
            minZoom: 1,
            maxZoom: _vm.options ? _vm.options.maxZoom : _vm.zoom.max.val,
            customEventsHandler: _vm.customEventsHandler,
          },
          on: { svgpanzoom: _vm.registerSvgPanZoom },
        },
        [
          _c("svg", { staticStyle: { width: "100%", height: "100%" } }, [
            _c("g", [_vm._t("default")], 2),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }